import React from 'react';
import { isString } from 'lodash';

var renderTitleNode = function renderTitleNode(title) {
  if ( /*#__PURE__*/React.isValidElement(title)) {
    return title;
  }
  if (isString(title)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ti-exception-title-content"
    }, title);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export { renderTitleNode as default };
